<script>
import AdsButton from '@/views/ads/components/AdsButton.vue'

export default {
  name: 'AdsPostpaidPaymentSuccess',
  components: {
    AdsButton,
  },
}
</script>

<template>
  <div class="ads-postpaid-payment-success">
    <div class="icon-container success-icon">
      <svg-icon icon-class="ads-success" />
    </div>
    <h1>{{ $t('ads_payment_successful') }}</h1>
    <p>{{ $t('ads_payment_success_msg') }}</p>
    <AdsButton
      variant="primary"
      class="mt-8 w-full"
      @click="$router.replace('/ads/postpaid/invoice')"
    >
      {{ $t('ads_dialog_close') }}
    </AdsButton>
  </div>
</template>

<style lang="scss" scoped>
.ads-postpaid-payment-success {
  display: contents;

  h1 {
    font-size: 28px;
  }

  .icon-container {
    svg {
      width: 72px;
      height: 72px;
    }
  }

  p {
    margin-top: 8px;
    color: var(--content-mid);
  }
}
</style>
